import * as React from 'react';

import { GoogleMapsProvider } from '@ttoss/google-maps';

import { env } from '@siflor/env';

const ConditionalGoogleMapsProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const apiKey = env.googleMaps.apiKey;

  if (!apiKey) {
    return <>{children}</>;
  }

  return (
    <GoogleMapsProvider apiKey={apiKey} libraries={['places']} language="pt-BR">
      {children}
    </GoogleMapsProvider>
  );
};

export default ConditionalGoogleMapsProvider;
